export enum GetSuggestKeywordModeEnum {
    Keyword = 'keyword',
    Category = 'category',
    Tag = 'tag',
    TargetAge = 'targetAge',
}